export default {
    langType: 'EN',
    public_head: {
        home: 'Home',
        cart: 'Cart',
        account_setting: 'setting',
        categories: 'Categories',
        coffee: 'Katffee',
        hotsale: 'Hot Item',
        special_offer: 'Special Offer',
        machine_location: 'KatKatMall',
        about_us: 'About Us',
        contact_us: 'Contact',
        please_sign: 'Please Login',
        register: 'Registration',
        welcome: 'Welcome，',
        personal_center: 'Personal Center',
        logout: 'Logout',
        favorites: 'Favorites',
        help_center: 'Help Center',
        macao: 'Macao, China',
        mainland: 'Chinese mainland',
        tips: 'Tips',
        tips_content: 'Are you sure to log out of the account？',
        cancel_text: 'Cancel',
        confirm_text: 'Confirm',
        points_mall: 'Points Mall',
        card_buy: 'Value Card'
    },
    goods: {
        settle: 'Buy It Now',
        add_cart: 'Add To The Cart',
        no_data: 'No corresponding data has been obtained yet！',
        Recommended_products: 'Recommended Products',
        more: 'More',
        limit_buy: 'Buy Now',
        sold_out: 'Sold out',
        all_goods: 'All Products',
        classify: 'Classification',
        brand: 'Brand',
        stock: 'Stock',
        unit: 'Unit',
        integral: 'Integral'
    },
    merchant_promise: {
        text1: 'Word of mouth',
        text2: 'Brand anti-counterfeiting code',
        text3: 'Trusted brand',
        text4: 'Complete categories',
        text5: 'Exquisite Service',
        text6: 'Daily Special Offer'
    },
    pay: {
        payment_method: 'Select Payment Method',
        hide_payment_methode_: 'Hide Payment Method',
        more_payment_method: 'More Payment Methods',
        payment: 'Pay Now'
    },
    public_footer: {
        text1: 'Brand anti-counterfeiting code',
        text2: 'Exclusive customer service 853-63005007',
        text3: '© 2009-2022 KatKatMall Copyright ',
        link: 'Guangdong ICP No. 2021154733'
    },
    forget: {
        forgot_pwd: 'Forgot Password',
        phone: `Phone Number'`,
        your_phone_tips: `Please enter your phone numberPlease enter your phone number`,
        phone_tips: 'Please enter your phone number',
        phone_regular_tips: 'Please enter the correct phone number',
        code: 'Verification Code',
        code_tips: 'Please enter the verification code',
        get_code: 'Get verification code',
        sent: 'Sent Already',
        new_pwd: 'New password',
        confirm_pwd: 'Password Confirmation',
        edit_pwd: 'Modify Password',
        pwd_tips: 'Please Enter New Password',
        pwd_regular_tips: 'Please enter a combination of 6-18 letters and numbers!',
        pwd_confirm_tips: 'Please Enter Your New Password Again',
        pwd_confirm_check_tips: 'Passwords entered twice do not match',
        reset_pwd: 'Password reset completed, Please go to login',
        tips: 'Tips',
        cancel_text: 'Cancel',
        confirm_text: 'Confirm',
    },
    login: {
        pwd_login: 'Password Login',
        code_login: 'SMS Login',
        scan_code_login: 'Scan QR Code To Login on WeChat',
        phone: 'Phone Number',
        phone_tips: 'Please Enter Your Phone Number First',
        code_tips: 'Please Enter The Verification Code',
        get_code: 'Get Verification Code',
        pwd_tips: 'Please Enter Password',
        login: 'Login',
        protocol_text1: 'By Logging In You Agree To',
        protocol_text2: `《KatKatMall User Agreement'》`,
        protocol_text3: 'And',
        protocol_text4: '《Privacy Policy》',
        forget_pwd: 'Forget Password',
        register: 'Free Registration',
        phone_regular_tips: 'Please Enter The Correct Phone Number',
        sent: 'Sent Already',
    },
    register: {
        user_register: 'User Register',
        phone: 'Phone Number',
        your_phone_tips: 'Please Enter Your Phone Number',
        phone_tips: 'Please Enter Phone Number',
        phone_regular_tips: 'Please Enter The Correct Phone Number',
        code: 'Verification Code',
        code_tips: 'Please Enter Verification Code',
        get_code: 'Get Verification Code',
        sent: 'Sent Already',
        pwd: 'Password',
        confirm_pwd: 'Password Confirmation',
        pwd_tips: 'Please Enter Password',
        protocol_text1: 'By Registering, You Agree To',
        protocol_text2: '《KatKatMall User Agreement》',
        protocol_text3: 'And',
        protocol_text4: '《Privacy Policy》',
        protocol_text5: 'Agree And Register',
        pwd_regular_tips: 'Please enter a combination of 6-18 letters and numbers!',
        pwd_confirm_tips: 'Please Enter Your Password Again',
        pwd_confirm_check_tips: 'Passwords entered twice do not match',
        register_success_tips: 'Registration Successful, Please go to login',
        tips: 'Tips',
        cancel_text: 'Cancel',
        confirm_text: 'Confirm',
    },
    cart: {
        home: 'Home Page',
        shop_cart: 'Cart',
        title_row1: 'Product Information',
        title_row2: 'Unit Price',
        title_row3: 'Quantity',
        title_row4: 'Amount',
        title_row5: 'Operate',
        original_price: 'Original Price',
        delete: 'Delete',
        empty: 'Empty Shopping Cart',
        allselect: 'All Select',
        total: 'Total',
        settle: 'Settlement',
        select_tips: 'Please Select Product',
        modal_text1: 'Are you sure you want to clear your shopping cart?',
        modal_text2: 'Are you sure you want to remove this item from your shopping cart?',
        tips: 'Tips',
        cancel_text: 'Cancel',
        confirm_text: 'Confirm',
        go_to_mall: 'Go to the mall',
        empty_tips: 'Master, there are no items in your shopping cart yet~',
        vemid: 'Device ID'
    },
    machine: {
        home: 'Home Page',
        machine_location: 'KatKatMall',
        location: 'Navigation',
        cart: 'Cart',
        back: 'Back',
        no_data: 'No corresponding data has been obtained yet！',
        area: 'Region',
        default: 'Default',
        distance_text1: 'From Far To Near',
        distance_text2: 'From Near To Far',
        all: 'All',
        vending_machine: 'KatKatMall',
        coffee_machine: 'Katffee',
        machine_no: 'Machine NO.'
    },
    member: {
        member_card_number: 'Membership Card Number',
        my_order: 'My Order',
        order_text1: 'All Orders',
        order_text2: 'Pending Payment',
        order_text3: 'To Be Picked Up',
        order_text4: 'Cancelled',
        order_text5: 'Completed',
        btn_tit: 'Common functions',
        btn_text1: 'Points Mall',
        btn_text2: 'My Favorites',
        btn_text3: 'Contact Customer Service',
        btn_text4: 'About Us',
        btn_text5: 'Log Out Of Account',
        btn_text6: 'My card wallet',
        tips: 'Tips',
        tips_content: 'Are you sure you want to log out?',
        cancel_text: 'Cancel',
        confirm_text: 'Confirm',
        coupon: 'My Coupon',
        coupon_title: 'Coupon',
        points: 'Integral'
    },
    member_info: {
        basic_info: 'Basic Information',
        avatar: 'Avatar',
        nickname: 'Nickname',
        nickname_tips: 'Please Enter A Nickname',
        sex: 'Gender',
        unknown: 'Unknown',
        male: 'Male',
        female: 'Female',
        security_settings: 'Security Settings',
        user_account: 'User Account',
        login_pwd: 'Login Password',
        edit_pwd: 'Modify Password',
        phone: 'Phone Number',
        change_tie: 'Change Binding',
        save: 'Save',
        reset_pwd: 'Reset Password',
        phone_tips: 'Please Enter your Phone Number',
        code: 'Verification Code',
        get_code: 'Get Verification Code',
        sent: 'Sent Already',
        pwd: 'Password',
        confirm_pwd: 'Confirm Password',
        protocol_text1: 'By Logging In You Agree To',
        protocol_text2: '《KatKatMall User Agreement》',
        protocol_text3: 'And',
        protocol_text4: '《Privacy Policy》',
        change_tie_phone: 'Change Bound Phone Number',
        your_phone_tips: 'Please Enter your Phone Number',
        previous: 'Previous Step',
        next_step: 'Next Step',
        pwd_tips: 'Please Enter Your Password',
        pwd_confirm_tips: 'Please Enter Your Password Again',
        pwd_confirm_check_tips: 'Passwords entered twice do not match',
        phone_check_tips: 'Please enter the correct phone number',
        upload_tips: 'Only jpeg/jpg/png format files can be uploaded',
        tips: 'Tips',
        tips_content: 'Password reset completed, please log in to your account again',
        cancel_text: 'Cancel',
        confirm_text: 'Confirm',
    },
    user_order: {
        title_row1: 'Product',
        title_row2: 'Unit Price',
        title_row3: 'Quantity',
        title_row4: 'Product Operation',
        title_row5: 'Actual Payment',
        title_row6: 'Transaction Status',
        title_row7: 'Transaction Operations',
        orderno: 'Order Number',
        self_code: 'Self Pickup Code',
        distance: 'Distance',
        original_price: 'Original Price',
        redemption_code: 'Redemption Code',
        Including_shipping: 'Including Shipping Cost',
        states_text1: 'Pending Payment',
        states_text2: 'To Be Self Picked Up',
        states_text3: 'Delivery In Progress',
        states_text4: 'Completed',
        states_text5: 'Cancelled',
        states_text6: 'Refund/After sales',
        order_detail: 'Order Details',
        settle: 'Go Settle',
        cancel_order: 'Cancel Order',
        delete_order: 'Delete Order',
        no_related_orders: 'There are currently no related orders',
        empty_tips: `Master, you haven't purchased any products recently~`,
        empty_btn: 'Go to the mall',
        code_text1: 'Please take a screenshot and save the redemption code below',
        code_text2: 'and pick up the goods from the selected machine within 30 days',
        code_text3: 'Redemption Code',
        payments: 'Payment In Progress',
        view_order_detail: 'View Order Details',
        tips: 'Tips',
        cancel_tips: 'Are you sure to cancel this order？',
        delete_tips: 'Are you sure to delete this order？',
        refund_tips: 'Are you sure you want to refund this order？',
        cancel_text: 'Cancel',
        confirm_text: 'Confirm',
        point: 'Integral',
        refund_status: 'Refund Status',
        exchange: 'Exchange',
        has_been: 'Already on',
        vemid: 'Device ID'
    },
    help: {
        home: 'Homepage',
        help_center: 'Help Center'
    },
    order_confirm: {
        checkout_page: 'Settlement Page',
        fill_tips: 'Fill in and verify order information',
        default: 'Default',
        paytype: 'Payment Method',
        goods_list: 'Product List',
        putaway: `Put it away`,
        expand: 'Expand',
        original_price: 'Original Price',
        amount: 'Product Amount',
        total: 'Actual Payment',
        payments: 'In Progress...',
        settle: 'Go Settle',
        payments_progress: 'Payment in Progress',
        view_order_detail: 'View Order Details',
        pickup: 'Self Pickup',
        coupon: 'Coupon',
        edit: 'Modify',
        coupon_available: 'Available',
        no_available: 'Currently Unavailable',
        no_use: 'Do Not Use Coupons',
		validity_period: 'Valid Until',
		full_text: 'Full',
		available: 'Available',
        select_coupon: 'Select Coupon',
        pay_tips: 'If payment cannot be made normally, please check your browser settings to see if pop ups are blocked. After modifying the settings, please return to the order page and try to make a new payment. If the problem persists, please contact our customer service staff in a timely manner. Thank you for your cooperation and understanding.',
        integral: ' Integral',
        paypoint: 'Payment Points',
        card_txt1: 'Send to friends',
		card_txt2: 'Yes',
		card_txt3: 'No',
		card_txt4: `Fill in your friend's mobile phone number`,
		card_txt5: 'Please enter your phone number'
    },
    order_detail: {
        title: 'Order Details',
        order_status: 'Order Status',
        status_text1: `Pending Payment`,
        status_text2: 'To be self picked up',
        status_text3: 'In Transit',
        status_text4: 'Completed',
        status_text5: 'Cancelled',
        status_text6: 'Refund/After Sales',
        distance: 'Distance',
        goods_list: 'Product List',
        redemption_code: 'Redemption Code',
        putaway: 'Put it away',
        expand: 'Expand',
        code_text1: 'Please take a screenshot and save the redemption code below',
        code_text2: 'and pick up the goods from the selected machine within 24 hours',
        code_text3: 'Redemption Code',
        code_text4: 'and pick up the goods from the selected machine within 30 days',
        payment_method: 'Payment Method',
        delivery_method: 'Delivery Method',
        home_delivery: 'Home Delivery',
        pickup: 'Vending Machine Self Pickup',
        orderno: 'Order Number',
        orderno_time: `Order Time`,
        pay_time: 'Payment time',
        amount: 'Product Amount',
        payable: 'To be Paid',
        total: 'Actual Payment',
        settle: 'Go Settle',
        cancel_order: 'Cancel Order',
        payments: 'Payment in Progress',
        view_order_detail: 'View Order Details',
        tips: 'Tips',
        cancel_tips: 'Are you sure to cancel this order?',
        refund_tips: 'Are you sure you want to refund this order?',
        cancel_text: 'Cancel',
        confirm_text: 'Confirm',
        not_order: 'Order does not exist',
        coupon: 'Coupon',
        point: 'Integral',
        refund_status: 'Refund Status',
        exchange: 'Exchange',
        has_been: 'Already on',
        refund_status_text: 'Refund Review Status',
		refund_pay_text: 'Refund received status',
		refund_amount: 'Refund amount',
        integral: ' Integral',
        paypoint: 'Payment Points',
        vemid: 'Device ID',
        close: 'Close',
        send_friend: 'Send to firend',
        card_num1: 'Total quantity',
		card_num2: 'Quantity to be redeemed ',
		card_change: 'Switch'
    },
    coupon: {
        validity_period: 'Valid Until',
		full_text: 'Full',
		available: 'Available',
		receive: 'Get it Now',
		receive_success: 'Received Successfully',
		settle: 'Go Settle',
		sold_out: 'Sold Out',
        use_desc: 'Usage Description'
    },
    goods_info: {
        home: 'Homepage',
        goods_detail: 'Product Details',
        all_goods: 'All Products',
		notice: 'Shopping Notice',
		add_cart: 'Add to Cart',
		buy: 'Buy Now',
		stock: 'Stock',
		unit: 'Unit',
		num: 'Quantity',
		confirm_text: 'Confirm',
		select_text: 'Selected',
		unfold: 'Expand',
		pickup: 'Put Away',
		vend_title: 'KatKatMall',
		location: 'Navigation',
		notice_content: 'The actual price of the product does not change due to differences in expression. The specific transaction price may change depending on whether the product participates in an event or whether members use coupons or points, etc. The final price is subject to the price on the order settlement page.',
		time_limit_title: 'Limited time purchase',
		time_limit_desc: 'Limited time and limited quantity, quick purchase',
		time_limit_tips_start: 'Only left until the start',
		time_limit_tips_conduct: 'Only left until the start',
		time_limit_tips_end: 'Ended',
		limit_buy: 'Buy Now',
		sale_out: 'Sold Out',
        wechat_scan: 'Scan WeChat',
        go_to_mall: 'Go to the mall',
        hot_sale: 'Hot Item',
        does_not_exist: 'The accessed product does not exist~',
        integral: 'Integral'
	},
    coupon_list: {
		title: 'Coupon',
		coupon_state: [{
			states: 0,
			name: 'Not Used'
		},{
			states: 1,
			name: 'Used'
		},{
			states: 2,
			name: 'Expired'
		}],
		loading: 'Loading in Progress',
		nomore: `It's already the end!`,
		none_order: `You don't have any relevant coupons yet`,
		desc_text1: 'Full Consumption',
		desc_text2: 'Available, Can Be Waived',
		use_btn: 'To Use',
        expired_btn: 'Expired',
        use_desc: 'Usage Description',
        used_btn: 'Used',
		coupon_desc1: 'Valid Until',
		coupon_desc2: 'Self service machine (self pickup) available',
		coupon_desc3: 'The final interpretation right belongs to KatKatMall',
        no_coupon: 'There are currently no relevant coupons available',
        all_available: 'Available for the entire venue',
        part_available: 'The specified product is available'
	},
    goods_collect: {
        home: 'Homepage',
        favorites: 'Favorites',
        remove_favorite: 'Remove Favorites',
        cancel_batch_management: 'Cancel Batch Management',
        batch_management: 'Batch Management',
        empty_favorites: 'Clear Favorites',
        all_select: 'Select All',
        go_to_mall: 'Go to the mall',
        empty_tips: `Master, you haven't collected any items yet~`,
        tips: 'Tips',
        clear_tips_content: 'Are you sure you want to clear your favorites?',
        remove_tips_content: 'Are you sure you want to remove the selected item from your favorites?',
        cancel_text: 'Cancel',
        confirm_text: 'Confirm',
	},
    points: {
        user_center: 'Personal Center',
        points_mall: 'Points Mall',
        integral: 'Integral',
        exchange: 'Exchange',
        tips: 'Tips',
		tips_content: 'Are you sure you want to redeem this product?',
		cancel_text: 'Cancel',
		confirm_text: 'Confirm',
        no_data: 'No corresponding data has been obtained yet!',
        exchange_record: 'Exchange Record',
		check: 'View',
    },
    record: {
        integral_detail: 'Integral Details',
        exchange_record: 'Exchange Record',
		rule_desc: 'View Rule Description',
		order: 'Order Number',
		addtime: 'Creation Time',
        integral: 'Integral',
        no_data: 'No corresponding data has been obtained yet!'
    },
    integral_detail: {
        home: 'Home Page',
		points_mall: 'Points Mall',
		integral: 'Integral',
		stock: 'Inventory quantity',
		exchange: 'Exchange Now',
		rule: 'Exchange Rules',
		more: 'View More',
		pickup: 'Put Away',
		unfold: 'Expand',
		detail: 'Product Details',
		unit: 'Unit',
		tips: 'Tips',
		tips_content: 're you sure you want to redeem this product？',
		cancel_text: 'Cancel',
		confirm_text: 'Confirm',
		vend_title: 'KatKatMall',
		location: 'Navigation'
	},
    card: {
		title: 'Monthly card purchase',
		detail_title: 'Details',
		validity: 'Validity',
		day: 'days',
		number: 'Remaining times',
		times: 'times',
		my_card: 'My card wallet',
		use_txt1: 'Used',
		use_txt2: 'Unused',
		use_txt3: 'Go to use',
		pop_txt1: 'Select coffee machine',
        value: 'Value'
	}
}